import request from "@/utils/request";


/* 获取企业分类 */
export function getEnterpriseCategory(query) {
  return request({
    url: '/?m=Auxfun&a=comCaseCategory',
    method: 'get',
    params: query
  })
}

/* 获取企业案例列表 */
export function getEnterpriseCaseList(query) {
  return request({
    url: '/?m=Auxfun&a=comCase',
    method: 'get',
    params: query
  })
}

/* 获取企业案例详情 */
export function getEnterpriseCaseDetail(id) {
  return request({
    url: '/?m=Auxfun&a=comCaseDetail',
    method: 'get',
    params: id
  })
}
